import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { getMe } from '@/api/auth';
import WidgetGrid from '@/components/dashboard/WidgetGrid';
import FopLimitsWidget from '@/components/dashboard/widgets/FopLimitsWidget';

/**
 * Auto-redirect для CASHIER_POS-only ролей (Порція Роздріб.6).
 *
 * Якщо у user серед access_role_codes є виключно касирські ролі
 * (CASHIER_POS / CASHIER_SENIOR) — авто-редіректимо на /pos.
 * Якщо є хоча б одна бух-роль — лишаємо у бух-UI (user сам обере).
 */
const CASHIER_ONLY_ROLES = new Set(['CASHIER_POS', 'CASHIER_SENIOR']);

function shouldAutoRedirectToPos(roles: string[] | undefined): boolean {
  if (!roles || roles.length === 0) return false;
  return roles.every((r) => CASHIER_ONLY_ROLES.has(r));
}

export default function HomePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const meQuery = useQuery({ queryKey: ['me'], queryFn: getMe });

  useEffect(() => {
    if (!meQuery.data) return;
    // OWNER/ADMIN — access_role_codes завжди порожній; залишаємо у бух-UI.
    if (meQuery.data.tenant_role !== 'MEMBER') return;
    if (shouldAutoRedirectToPos(meQuery.data.access_role_codes)) {
      navigate('/pos', { replace: true });
    }
  }, [meQuery.data, navigate]);

  return (
    <>
      <div className="card">
        <h2 style={{ marginTop: 0 }}>{t('home.welcome')}</h2>
        <p>{t('home.description')}</p>
      </div>
      <WidgetGrid>
        <FopLimitsWidget />
        {/* Block 10 (2026-05-27): first widget; майбутні widgets — тут */}
      </WidgetGrid>
    </>
  );
}

export { shouldAutoRedirectToPos };

